<ng-container *ngIf="featureRemoteController$ | async | ready as remoteController">
  <div class="ventilation-settings-tile flex flex-col gap-[24px] flex-[1_0_100%]">
    <div class="flex flex-row">
      <h3>{{ '+INSTALLATIONS.INSTALLATION.REMOTE_CONTROLLER.TITLE' | translate }}</h3>
    </div>

    <ng-container *ngIf="remoteController.properties?.deviceId?.value">
      <div class="feature-description">
        {{ installationFeaturesStore.selectRemoteDeviceType(featureName) | async }} ({{
          remoteController.properties?.deviceId?.value | idPrefixRemover | serialSpacing
        }})
      </div>
    </ng-container>

    <div>
      <button
        *ngIf="
          remoteController.commands?.setZigbeeController?.params?.deviceId?.constraints?.enum
            ?.length > 0 && !remoteController.properties?.deviceId?.value
        "
        data-at-remote-controller-btn-assign
        mat-stroked-button
        color="primary"
        gtm="onAssignDevice"
        gtmAction="Assign Vitotrol Device"
        gtmCategory="assignRemoteControllerDevice"
        [disabled]="!remoteController.commands?.setZigbeeController?.isExecutable"
        (click)="openAssignRemoteControllerDialog()"
      >
        <mat-icon>add</mat-icon>
        <span>{{ '+COMMISSIONING.BUTTON.ASSIGN_DEVICE' | translate }}</span>
      </button>
      <button
        *ngIf="remoteController.properties.deviceId?.value"
        data-at-remote-controller-btn-delete
        mat-stroked-button
        color="primary"
        gtm="onUnassignDevice"
        gtmAction="Unassign Vitotrol Device"
        gtmCategory="assignRemoteControllerDevice"
        [disabled]="!remoteController.commands?.removeZigbeeController?.isExecutable"
        (click)="unassignRemoteControllerDevice()"
      >
        <mat-icon>delete</mat-icon>
        <span>{{ '+COMMISSIONING.BUTTON.UNASSIGN_DEVICE' | translate }}</span>
      </button>
    </div>
  </div>
</ng-container>
